import defaultMuiTheme from './default';
const { shadows } = { ...defaultMuiTheme };
shadows[4] = '0px 2px 16px 0px rgba(153,155,168,0.2)';
export default shadows;
//# sourceMappingURL=shadows.js.map